import React from 'react';
import { Navigation } from '../../../global-functions';
import { ICartItemInfo } from '../../../models/pro-sites';
import Modal, { IModalChildProps } from '../../common/modal';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';

const SavedForLaterModal = ({ onClose, onAccept }: IModalChildProps) => {
    const intl = useIntl();
    return (
        <Modal>
            <div className="modal-content">
                <>
                    <div className="modal-header">
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label={'close'}
                            onClick={onClose}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 className="modal-title">
                            {intl.formatMessage({
                                id: 'Items_that_are_currently_in_yo',
                                defaultMessage: `Items that are currently in your Cart will be saved
                            for later`,
                            })}
                        </h4>
                    </div>
                    <div className="modal-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <p>
                                    {intl.formatMessage({
                                        id: 'Patient_orders_must_be_separate',
                                        defaultMessage: `Patient orders must be submitted separately
                                    from all other orders. If you click
                                    Continue, items that are currently in your
                                    Cart will be saved for later in Cart.`,
                                    })}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <span className="pull-right">
                            <button
                                className="btn btn-default"
                                onClick={onClose}
                            >
                                {intl.formatMessage({
                                    id: 'Cancel',
                                    defaultMessage: 'Cancel',
                                })}
                            </button>
                            <button className="btn btn-info" onClick={onAccept}>
                                {intl.formatMessage({
                                    id: 'Continue',
                                    defaultMessage: 'Continue',
                                })}
                            </button>
                        </span>
                    </div>
                </>
            </div>
        </Modal>
    );
};

export default SavedForLaterModal;
